import Scrollbar from 'smooth-scrollbar'

export default function SmoothScrollbar(container) {
    Scrollbar.init(container, {
        alwaysShowTracks: true,
    })
}
